import React, { useState } from "react";
import MoreButton from "../Button/MoreButton";

// A reusable data array for your FAQs
const faqs = [
  {
    question: "How do I place an order for steel products?",
    answer:
      "You can place an order by contacting our sales team via phone, email, or through our website’s inquiry form. Once we receive your request, we’ll confirm availability, pricing, and delivery details.",
  },
  {
    question: "Can I cancel or modify my order after placing it?",
    answer:
      "Yes, you can cancel or modify your order before it has been processed or dispatched. Please contact our sales team as soon as possible to make changes.",
  },
  {
    question: "Do you provide delivery services?",
    answer:
      "Yes, we offer delivery within the city and to selected regions. Delivery costs and timelines depend on the order size, weight, and destination.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept bank transfers, mobile money, and company cheques. For first-time clients, advance payment may be required before dispatching the goods.",
  },
  {
    question: "Can I request custom sizes or cutting services?",
    answer:
      "Absolutely. We provide cutting and sizing services for most steel products. Share your specific requirements with our sales team when placing your order.",
  },
];

const FAQAccordion = () => {
  // `useState` hook to keep track of the currently open accordion index.
  // We initialize it to `null` so no accordion is open by default.
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index: any) => {
    // If the clicked accordion is already open, close it.
    // Otherwise, open the new one and close the old one.
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="bg-white pt-48 pb-36 px-10 sm:px-20 lg:px-32 flex flex-col lg:flex-row items-center justify-between gap-[56px]"
      id="FAQ"
    >
      <div className="w-full lg:w-[47%] lg:max-w-[593px]">
        <span className="inter-black text-[#EEB762] text-2xl">
          FREQUENTLY ASKED QUESTIONS
        </span>
        <h3 className="text-[#24215A] changa-one-regular text-4xl sm:text-6xl mb-6 mt-3">
          Answers to Help You Order With Confidence
        </h3>
        <p className="text-xl actor-regular text-[#9A9A9A] mb-8">
          Find quick answers to common questions about ordering, payment, and
          delivery of our steel products. If you don't see your question here,
          feel free to contact us directly.
        </p>
        {/* <button className="bg-[#EEB762] py-[18px] px-[60px] rounded-[6px] text-sm">
          <span className="text-sm text-white">View All FAQs</span>
        </button> */}
      </div>
      <div className="w-full lg:max-w-[47%] rounded-lg bg-[#FBF9F9]">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-200 last:border-b-0">
            <button
              onClick={() => toggleAccordion(index)}
              className="flex w-full items-center justify-between p-6 text-left focus:outline-none"
            >
              <span className="text-lg font-semibold text-gray-700">
                {faq.question}
              </span>
              <span
                className={`transform transition-transform duration-300 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? "max-h-96" : "max-h-0"
              }`}
            >
              <p className="px-6 pb-6 text-gray-600">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAccordion;
